import comp from "./ChangeTaskType.js";
export default comp;
